app.factory('cmsPagination', [function () {
    return {
        preparePagination: function (countTotalResults, pageSize, pageNumber, descending) {
            var requestObj = {
                pageNumber: pageNumber ? pageNumber : 1,
                pageSize: pageSize ? pageSize : 40
            };
            if (countTotalResults) {
                requestObj.countTotalResults = countTotalResults;
            } else {
                requestObj.countTotalResults = true;
            }
            if (descending) {
                requestObj.descending = descending;
            } else {
                requestObj.descending = true;
            }
            return requestObj;
        }
    }
}]);